"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_DEFENSE_TO_REIGN: function() {
        return ADD_DEFENSE_TO_REIGN;
    },
    ADD_REIGN: function() {
        return ADD_REIGN;
    },
    CREATE_REIGN: function() {
        return CREATE_REIGN;
    },
    DELETE_REIGN: function() {
        return DELETE_REIGN;
    },
    DUPLICATE_REIGN: function() {
        return DUPLICATE_REIGN;
    },
    END_REIGN: function() {
        return END_REIGN;
    },
    GENERATE_REIGNS: function() {
        return GENERATE_REIGNS;
    },
    NEW_CHAMPIONS: function() {
        return NEW_CHAMPIONS;
    },
    REMOVE_DEFENSE_FROM_REIGN: function() {
        return REMOVE_DEFENSE_FROM_REIGN;
    },
    RESET_REIGNS: function() {
        return RESET_REIGNS;
    },
    START_REIGN: function() {
        return START_REIGN;
    },
    UPDATE_REIGN: function() {
        return UPDATE_REIGN;
    }
});
const ADD_REIGN = "ADD_REIGN";
const UPDATE_REIGN = "UPDATE_REIGN";
const DELETE_REIGN = "DELETE_REIGN";
const GENERATE_REIGNS = "GENERATE_REIGNS";
const RESET_REIGNS = "RESET_REIGNS";
const DUPLICATE_REIGN = "DUPLICATE_REIGN";
const END_REIGN = "END_REIGN";
const START_REIGN = "START_REIGN";
const ADD_DEFENSE_TO_REIGN = "ADD_DEFENSE_TO_REIGN";
const REMOVE_DEFENSE_FROM_REIGN = "REMOVE_DEFENSE_FROM_REIGN";
const CREATE_REIGN = "CREATE_REIGN";
const NEW_CHAMPIONS = "NEW_CHAMPIONS";
